module.exports = __webpack_public_path__ + "static/media/textsecuritydisc.5db9df29.ttf";